import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';
import ArgonButton from 'component/Argon/ArgonButton';

import DashboardLayout from 'layout/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'component/Navbars/DashboardNavbar';

import DataTable from 'component/Tables/DataTable';

import MiniStatisticsCard from 'component/Card/StatisticsCards/MiniStatisticsCard';
import { usePolicyStat } from 'api/getPolicyStat';
import { useState } from 'react';
import { format } from 'date-fns';
import usePkg from 'hook/usePkg';
import FlickerBox from 'component/Flicker';
import ModalAlert from 'page/sign-in/ModalAlert';

/**
 *
 * NOTE: icon used by add _ to sapaparate camelCase
 */

export default function Dashboard() {
  const { credit } = usePkg();
  const [today] = useState(format(new Date(), 'dd/MM/yy'));
  const [modal, setModal] = useState(true);
  const { data } = usePolicyStat(today);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox>
        {/* <DashboardInfoCard /> */}
        <ArgonBox mb={3} px={3} position="relative" sx={{ backgroundColor: 'red', borderRadius: 4 }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={12}>
              <FlickerBox>
                <ArgonTypography variant="body2" color="white">
                  *** ซื้อประกันเพื่อใช้ต่ออายุใบอนุญาตทำงาน ในช่องเลขที่ประจำตัว ให้ใส่ เลขรหัสต่างด้าว13หลัก เท่านั้น
                </ArgonTypography>
                <ArgonBox mt={1} mb={2}>
                  <ArgonTypography variant="body2" color="white">
                    และเลือกประเภทเลขที่ประจำตัว เป็น Work Permit *
                  </ArgonTypography>
                </ArgonBox>
              </FlickerBox>
            </Grid>
          </Grid>
        </ArgonBox>
        <Grid container spacing={3} mb={3}>
          <MinimalCard
            title={{ text: 'จำนวนแรงงาน', fontWeight: 'medium' }}
            count={`${data.total} คน`}
            icon={{ component: 'person', color: 'info' }}
          />
          <MinimalCard
            title={{ text: 'จำนวนกรมธรรม์', fontWeight: 'medium' }}
            count={`${data.totalSuccess} รายการ`}
            icon={{ component: 'assignment_ind', color: 'info' }}
          />
          <MinimalCard
            title={{ text: 'กรมธรรม์หมดอายุแล้ว', fontWeight: 'medium' }}
            count={`${data.totalExp3m + data.totalExp6m + data.totalExp1y + data.totalExp15m} รายการ`}
            icon={{ component: 'assignment_late', color: 'error' }}
          />
          {/* <MinimalCard
            title={{ text: 'ส่วนลดสำหรับ 6 เดือน', fontWeight: 'medium' }}
            count={`${discount?.['6m'] || 0} บาท`}
            icon={{ component: 'celebration', color: 'success' }}
          />
          <MinimalCard
            title={{ text: 'ส่วนลดสำหรับ 12 เดือน', fontWeight: 'medium' }}
            count={`${discount?.['1y'] || 0} บาท`}
            icon={{ component: 'celebration', color: 'success' }}
          />
          <MinimalCard
            title={{ text: 'ส่วนลดสำหรับ 15 เดือน', fontWeight: 'medium' }}
            count={`${discount?.['15m'] || 0} บาท`}
            icon={{ component: 'celebration', color: 'success' }}
          /> */}
          <MinimalCard
            title={{ text: 'เครดิต', fontWeight: 'medium' }}
            count={`${credit || 0} บาท`}
            icon={{ component: 'credit_card', color: 'success' }}
          />
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ArgonBox>
              <Card>
                <ArgonBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
                  <ArgonBox lineHeight={1}>
                    <ArgonTypography variant="h5" fontWeight="medium">
                      กรมธรรม์หมดอายุ
                    </ArgonTypography>
                    <ArgonTypography variant="button" fontWeight="regular" color="text">
                      รายการกรมธรรม์ที่หมดอายุของแรงงาน
                    </ArgonTypography>
                  </ArgonBox>
                  <Stack spacing={1} direction="row">
                    <ArgonButton variant="gradient" color="info" size="small">
                      + Export
                    </ArgonButton>
                  </Stack>
                </ArgonBox>
                <ArgonBox px={3}>
                  <DataTable
                    table={{
                      columns: [
                        { Header: 'ชื่อ', accessor: 'name' },
                        { Header: 'เลขประจำตัว', accessor: 'idCard' },
                        { Header: 'เลขที่กรมธรรม', accessor: 'policyNo' },
                      ],
                      rows: [],
                    }}
                    entriesPerPage={{
                      defaultValue: 10,
                      entries: [5, 10, 15, 20, 25],
                    }}
                    canSearch
                  />
                </ArgonBox>
              </Card>
            </ArgonBox>
          </Grid>
        </Grid>
      </ArgonBox>
      <ModalAlert open={modal} handleClose={() => setModal(false)} />
    </DashboardLayout>
  );
}

function MinimalCard({ title, count, icon }) {
  return (
    <Grid item xs={12} md={6} lg={4}>
      <MiniStatisticsCard title={title} count={count} icon={icon} />
    </Grid>
  );
}
